import { styled } from "@mui/material/styles";
import { Box, Switch, TextField, useTheme } from "@mui/material";
import { forwardRef } from "react";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "&.MuiSwitch-root": {
    padding: "10px",
    marginLeft: "6px",
  },
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    color: theme.palette.grey[50],
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: theme.palette.primary.main,
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.common.white
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 0.35,
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 32,
    height: 32,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.common.black
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.grey[400],
    borderRadius: 20 / 2,
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-disabled.Mui-disabled:not(.Mui-checked)":
    {
      color: theme.palette.grey[400],
      opacity: 0.35,
    },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-disabled.Mui-disabled": {
    color: "rgb(167, 189, 227)",
  },
}));

const InputComponent = forwardRef(({ ...props }, inputRef) => (
  <Box ref={inputRef} style={{ display: "flex" }} {...props} />
));

const OutlinedDiv = ({ children, label }) => {
  const theme = useTheme();

  return (
    <TextField
      id="custom-switch"
      sx={{
        "& .MuiFormControlLabel-root": {
          flex: 1,
          justifyContent: "space-between",
        },
        "& .MuiFormLabel-root.Mui-focused": {
          color: theme.palette.primary.main,
        },
      }}
      variant="outlined"
      label={label}
      slotProps={{
        htmlInput: { children: children },
        inputLabel: { shrink: true },
        input: {
          inputComponent: InputComponent,
        },
      }}
    />
  );
};

export { CustomSwitch, OutlinedDiv };
